module.exports = __webpack_public_path__ + "static/media/masterpageicon.c745b64d.svg";